{
  "greeting": "Hey, moi c'est Nova. C'est quoi ton objectif ? On trouve les bonnes recrues et on attaque vite.",
  "composer.placeholder": "Dis-moi ce que tu veux accomplir…",
  "send": "Envoyer",
  "hero.title": "Construis ton équipe IA",
  "hero.subtitle": "Décris ton objectif, Nova s'occupe du reste.",
  "chip.marketing": "Équipe marketing",
  "chip.dev": "Équipe dev",
  "chip.sales": "Équipe sales"
}
